import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Button from 'components/common/Button/Button'

const FixedNotification = ({ addVehicle, setVisible }) =>
  <Wrapper>
    <Notification>
      <AlertIcon asset="alert-triangle-black" alt="Black alert triangle" />
      <Text>Please add a vehicle to shop products that are compatible.</Text>
    </Notification>
    <AddVehicleButton onClick={ addVehicle }>Add Vehicle</AddVehicleButton>
    <CloseButton onClick={ () => { setVisible(false) } }>X</CloseButton>
  </Wrapper>

FixedNotification.propTypes = {
  addVehicle: PropTypes.func,
  setVisible: PropTypes.func
}

export default FixedNotification

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 65px;
  position: fixed;
  bottom: 0%;
  left: 0%;
  right: 0%;
  z-index: 100;
  width: 100%;
  background-color: ${Theme.colors.light_orange};
  ${Media.mobile`
    height: 135px;
    flex-direction: column;
  `}
`

const Notification = styled.div`
  display: flex;
  align-items: center;
  ${Media.mobile`
    flex-direction: column;
  `}
`

const AlertIcon = styled(Icon)`
  height: 30px;
  margin-left: 40px;
  ${Media.mobile`
    position: absolute;
    left: -20px;
    top: 30px;
  `}
`

const Text = styled.p`
  margin-left: 20px;
  font-weight: 700;
  ${Media.mobile`
    margin: 30px 40px 20px 60px
  `}
`

const AddVehicleButton = styled(Button)`
  margin-left: 40px;
  border-radius: 4px;
  background-color: ${Theme.colors.black};
`

const CloseButton = styled(Button)`
  position: absolute;
  right: 30px;
  background-color: ${Theme.colors.black};
  border: none;
  border-radius: 50%;
  font-size: 16px;
  padding: 4px 10px;
  cursor: pointer;
  ${Media.mobile`
    top: 10px;
    right: 10px;
  `}
`
